<div class="fonts text-style">
  <div class="alert alert-success" *ngIf="kpiSuccess">
    Initiative saved successfully!
  </div>
  <div class="alert alert-success" *ngIf="hoshinSubmit">
    Hoshin submitted successfully!
  </div>
  <div class="alert alert-success" *ngIf="hoshinApproved">
    Initiative Approved successfully!
  </div>
  <div class="alert alert-success" *ngIf="hoshinRejected">
    Initiative Rejected successfully!
  </div>
  <div class="alert alert-success" *ngIf="overallHoshinApproved">
    Hoshin Approved successfully!
  </div>
  <div class="alert alert-success" *ngIf="overallHoshinRejected">
    Hoshin Rejected successfully!
  </div>
  <div class="alert alert-success" *ngIf="kpiReviewSaved">
    KPI's Review Saved successfully!
  </div>
  <div class="alert alert-danger" *ngIf="kpiExist">KPI'already exists!</div>
  <div class="col-md-12 container-fluid text-style" style="padding: 2% 5%">
    <div class="col-md-12 pl-0 col-xs-12 col-sm-12 mb-4 heading1">
      <span class="span-create-edit-hoshin1 color">HOSHIN</span>
      <span class="pt-1" *ngIf="(this.adminId=='1')" style="font-size: 13px;"><a href="assets/userguides/HoshinUserguideForSuperAdmins.pdf" download class="pl-3 download-link">User Guide</a></span>
      <span class="pt-1" *ngIf="(this.adminId=='2' || this.adminId=='3' || this.adminId=='4' || this.isbpgLeadAdmin || this.isbpgAdmin || this.isNaacAdmin)" style="font-size: 13px;"><a href="assets/userguides/HoshinChapterAdminUserGuide.pdf" download class="pl-3 download-link">User Guide</a></span>
    </div>
    <div class="font-weight-bold" [ngStyle]="{ marginTop: adminId == '1' && selectedChapter ? '15px' : '0%' }">
      <div *ngIf="adminId != '1' && adminId != '4'">
        <span class="text-style color">Hoshin : </span>
        <span class="text-style ml-1">{{ siteName }} - {{ bpgName }}
          <span class="ml-1 mr-1 color">FY {{ fiscalYear }}</span>
          <span *ngIf="isAddNewInitiative">
            > {{ initiativeName }}</span>
        </span>
        <span style="float: right;" *ngIf="
          (adminId == '1' && selectedChapter) || adminId == '2' || adminId == '3' || isbpgAdmin || isbpgLeadAdmin
        ">
          Status :
          <span class="color">{{ overallStatus }}</span>
        </span>
      </div>
      <div *ngIf="adminId == '1' && selectedChapter" class="text-style font-weight-bold mt-2">
        <span style="font-weight: normal; font-size: 10px;">Showing for</span>
        <span class="color ml-1 mr-1">{{ siteName }}</span> {{ bpgName }}
        <span class="color ml-1"> FY {{ fiscalYear }}</span>
        <span class="ml-1" *ngIf="isAddNewInitiative">
          > {{ initiativeName }}</span>
        <span style="float: right;" *ngIf="
          (adminId == '1' && selectedChapter) || adminId == '2' || adminId == '3' 
        ">
          Status :
          <span class="color">{{ overallStatus }}</span>
        </span>
      </div>

    </div>
    <div *ngIf="(adminId == '4') && selectedChapter" class="text-style font-weight-bold mt-2"
      [ngStyle]="{ marginTop: adminId == '4' && selectedChapter ? '25px' : '0px' }">
      <span style="font-weight: normal; font-size: 10px;">Showing for</span>
      <span class="color  ml-1 mr-1">{{ siteName }}</span> {{ bpgName }}
      <span class="color ml-1"> FY {{ fiscalYear }}</span>
      <span style="float: right;" *ngIf="overallStatus=='APPROVED' || overallStatus == 'REJECTED'">
        Status : <span class="color">{{ overallStatus }}</span></span>
    </div>
    <div class="row" *ngIf="
        adminId == '3' ||
        adminId == '2' ||
        isbpgAdmin ||
        isbpgLeadAdmin ||
        (adminId == '1' && selectedChapter) ||  (adminId == '4' && selectedChapter)
      ">

      <div class="col-md-3 mt-4">
        <div *ngIf="selectedChapter">
          <ul class="nav flex-column nav-pills" role="tablist" *ngFor="let i of yearList">
            <li class="nav-item" *ngIf="i.enabled">
              <a id="currentYearDisplay" class="nav-link cursor-pointer" [ngClass]="{'active': i.isActive == true }"
                data-toggle="pill" (click)="changeIsActive(i)">FY {{ i.year }} {{ i.type | titlecase }}</a>
            </li>

            <li class="nav-item" *ngIf="!i.enabled">
              <a class="nav-link pointerDisable" data-toggle="pill">FY {{ i.year }} {{ i.type | titlecase }}</a>
            </li>
          </ul>
        </div>

        <div class="mb-3" [ngStyle]="{ marginTop: '15px' }" *ngIf="currentHoshin.length>0"><b>Current Hoshin</b>
          <ul class="nav flex-column nav-pills mt-2 mb-1" style="border-left: none" role="tablist"
            *ngFor="let i of currentHoshin">
            <li class="nav-item">
              <a id="currentYearDisplay" class="nav-link cursor-pointer"
                style="background-color: #e2dfdf !important; color: black" data-toggle="pill">FY {{ i.fiscalYear }}
                <span style="float: right" class="mr-3">
                  <mat-icon class="align-end" style="font-size: 18px !important; color: black"
                    (click)="selectHoshin(i.budgetId)">print</mat-icon>
                </span></a>
            </li>
          </ul>
        </div>
        <div class="mb-3" [ngStyle]="{ marginTop: adminId == '4' && selectedChapter ? '15px' : '15px' }"
          *ngIf="pastHoshinList.length>0"><b>Past Hoshins</b></div>
        <ul class="nav flex-column nav-pills mb-1" style="border-left: none" role="tablist"
          *ngFor="let i of pastHoshinList">
          <li class="nav-item">
            <a id="currentYearDisplay" class="nav-link cursor-pointer"
              style="background-color: #e2dfdf !important; color: black" data-toggle="pill">FY {{ i.fiscalYear }}
              <span style="float: right" class="mr-3">
                <mat-icon class="align-end" style="font-size: 18px !important; color: black"
                  (click)="selectHoshin(i.budgetId)">print</mat-icon>
              </span></a>
          </li>
        </ul>
      </div>

      <div class="col-md-9 mt-4 pr-0" *ngIf="displayType == 'reflection'">
        <div class="mb-3 col-sm-6 text-secondary information">
          <span>
            <mat-icon class="info-icon">info</mat-icon>
          </span>
          <span style="padding-top: 2px;">Section to review current Fiscal year's Progress </span>
        </div>
        <button class="btn btn-goals col-sm-3 curve-edge button-font button-width"
          *ngIf="!isAddNewInitiative && hoshinList.length>0" (click)="selectKPIsReview()"
          [ngClass]="{ goalsButton: isOverallReviewSelected }">
          KPIs Review
        </button>
        <button class="btn btn-goals col-sm-3 curve-edge button-font button-width"
          *ngIf="!isAddNewInitiative && kpiReviewMissingFields == ''" (click)="selectOverallReview()"
          [ngClass]="{ goalsButton: isKpiReviewSelected }">
          Overall Review
        </button>
        <div class="col-sm-12 mb-2" *ngIf="isKpiReviewSelected && !isOverallReviewSelected">
          <div class="mt-3 text-secondary information"
            *ngIf="hoshinList.length>0">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please review the KPIs for all the initiatives . You can do this by
              selecting the evaluations for each initiative using the buttons provided in the table below. </span>
          </div>
          <div class="card card-style-review mt-3" *ngIf="hoshinList.length>0">
            <div class="m-4 table-container">
              <table aria-describedby="table" [ngClass]="{ 'table-responsive': tableresp }" class="table table-striped"
                id="tabledemo">
                <thead>
                  <tr class="tr-th">
                    <th scope="col" style="width: 30%">BPG Initiative</th>
                    <th scope="col" style="width: 60%">
                      Evaluation<span class="text-secondary pl-1" style="font-size: 11px">
                        Click to Update</span>
                    </th>
                    <th scope="col" style="width: 50%">View</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of hoshinList; let i = index">
                    <td>{{ data.bpgInitiative }}</td>
                    <td>
                      <button style="margin-left: 0px" class="btn btn-kpi col-sm-2 curve-edge button-font button-width"
                        [ngClass]="{
                          'btn-met': data.evaluation == 'Met',
                          'btn-opc':
                            data.evaluation == 'Partially Met' ||
                            data.evaluation == 'Incomplete'
                        }" (click)="data.evaluation = 'Met'"
                        [disabled]="adminId == '4'">
                        Met
                      </button>
                      <button class="btn btn-kpi col-sm-4 curve-edge button-font button-width" [ngClass]="{
                          'btn-partiallyMet':
                            data.evaluation == 'Partially Met',
                          'btn-opc':
                            data.evaluation == 'Met' ||
                            data.evaluation == 'Incomplete'
                        }" (click)="data.evaluation = 'Partially Met'"
                        [disabled]="adminId == '4'">
                        Partially Met
                      </button>
                      <button class="btn btn-kpi col-sm-3 curve-edge button-font button-width" [ngClass]="{
                          'btn-incomplete': data.evaluation == 'Incomplete',
                          'btn-opc':
                            data.evaluation == 'Partially Met' ||
                            data.evaluation == 'Met'
                        }" (click)="data.evaluation = 'Incomplete'"
                        [disabled]="adminId == '4'">
                        Incomplete
                      </button>
                    </td>
                    <td>
                      <a><img src="assets/images/view.png" alt="Angular Logo" class="image cursor-pointer"
                          style="width: 20px !important" title="View Initiative" id="bsaeHoshin{{ i }}"
                          (click)="getBaseHoshin(data, i)" /></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="col-md-12 mt-5 text-center">
            <div *ngIf="kpiReviewMissingFields != '' && submitButtonClicked" class="color mb-3">
              {{kpiReviewMissingFields}}
            </div>
            <button *ngIf="adminId!='4' && hoshinList.length>0"
              class="btn btn-danger col-sm-2 button-font" (click)="updateReview('partialSave')">
              Save
            </button>
            <button *ngIf="adminId!='4' && hoshinList.length>0"
              class="btn btn-danger col-sm-2 button-font"
              (click)="checkAllMandatoryDetailsFilledForReview('kpiReview')">
              Save and Proceed
            </button>
            <button *ngIf="adminId=='1' || !singleChapterAdmin" class="btn btn-danger col-sm-2 button-font"
              data-toggle="modal" data-target="#myModal" (click)="screenExit()">
              Cancel
            </button>
          </div>
        </div>
        <div class="col-sm-12" *ngIf="!isKpiReviewSelected && isOverallReviewSelected" class="text-style">
          <div class="mt-3 ml-4 text-secondary information" *ngIf="!highlights">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please outline the key achievements for this fiscal year.</span>
          </div>
          <div style="display: flex" class="mt-4">
            <div class="col-md-3">
              <span class="font-weight-bold col-md-4">FY {{ fiscalYear }} Highlights
                <span class="mandatory-asterisk">*</span> </span>
            </div>
            <div class="col-md-9">
              <textarea class="form-control" rows="7" [(ngModel)]="highlights" id="highlights"
                name="highlights" maxlength="500" [disabled]="adminId==4"
                required>
                </textarea>
            </div>
          </div>
          <div class="mt-3 ml-4 text-secondary information" *ngIf="!challenges">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please detail the main challenges encountered during this fiscal
              year.</span>
          </div>
          <div style="display: flex" class="mt-3 mb-2">
            <div class="col-md-3">
              <span class="font-weight-bold col-md-4">FY {{ fiscalYear }} Challenges
                <span class="mandatory-asterisk">*</span></span>
            </div>
            <div class="col-md-9">
              <textarea class="form-control" rows="7" [(ngModel)]="challenges" id="challenges"
                name="challenges" maxlength="500" [disabled]="adminId==4"
                required>
                </textarea>
            </div>
          </div>

          <div class="col-md-12 mt-5 text-center">
            <div *ngIf="overallReviewMissingFields != '' && submitButtonClicked" class="color mb-3">
              {{overallReviewMissingFields}}
            </div>
            <button *ngIf="adminId!= '4'"
              class="btn btn-danger col-sm-2 button-font"
              (click)="checkAllMandatoryDetailsFilledForReview('overallReview')">
              Save and Proceed
            </button>
            <button *ngIf="adminId=='1' || !singleChapterAdmin" class="btn btn-danger col-sm-2 button-font"
              data-toggle="modal" data-target="#myModal" (click)="screenExit()">
              Cancel
            </button>
          </div>
        </div>
        <app-confirmation-modal [PData]="msg" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
      </div>

      <div class="col-md-9 mt-4 pr-0"
        *ngIf="displayType == 'plan'  && (adminId =='1' || adminId == '2' || adminId == '3'|| isbpgAdmin || isbpgLeadAdmin || (adminId == '4'  && (overallStatus == 'APPROVED' || overallStatus == 'REJECTED')))">
        <div *ngIf="isGoalsSelected || isInitiativesSelected" class="mb-3 col-sm-6 text-secondary information">
          <span>
            <mat-icon class="info-icon">info</mat-icon>
          </span>
          <span style="padding-top: 2px;">Section to Plan for upcoming Fiscal year </span>
        </div>
        <button class="btn btn-goals curve-edge button-font button-width-goals" *ngIf="!isAddNewInitiative"
          (click)="selectGoals()" [ngClass]="{ goalsButton: !isGoalsSelected }">
          Goals
        </button>
        <button class="btn btn-goals curve-edge button-font button-width-goals"
          *ngIf="!isAddNewInitiative && overallStatus != 'NEW'" (click)="selectInitiative()"
          [ngClass]="{ goalsButton: !isInitiativesSelected }">
          Initiatives
        </button>
        <button class="btn btn-danger col-sm-3 button-font button-width-initiative float-right" *ngIf="
            isInitiativesSelected &&
            !isAddNewInitiativeSelected &&
            !readOnly &&
            !adminsEdit && adminId != '4'
          " (click)="addNewInitiative()">
          Add Initiative
        </button>
        <button class="btn btn-danger col-sm-3 button-font button-width-copy-initiative float-right" *ngIf="
            !isAddNewInitiative &&
            isInitiativesSelected &&
            !readOnly &&
            !adminsEdit && prevInitiativeList.length>0 && adminId != '4'
          " (click)="copyData('iniative')" [disabled]="cloneDisable">
          Copy FY{{ prevFyShort }} Initiatives
        </button>
        <button class="btn btn-goals col-sm-3 curve-edge button-font button-width mb-3 ml-2" *ngIf="isAddNewInitiative"
          (click)="detailsClick()" [ngClass]="{ goalsButton: isKpiClicked }">
          Details
        </button>
        <button class="btn btn-goals col-sm-3 curve-edge button-font button-width mb-3"
          *ngIf="isAddNewInitiative && hoshinId>0" (click)="kpiClick()" [disabled]="kpiDisable()"
          [ngClass]="{ goalsButton: isDetailsClicked }">
          KPIs
        </button>
        <button class="btn btn-goals col-sm-3 curve-edge button-font button-width mb-3"
          [ngClass]="{ goalsButton: !approveOrRejectHoshin }" *ngIf="
            isAddNewInitiative &&
            hoshinId != 0 &&
            overallStatus == 'SUBMITTED' &&
            adminId == '1'
          " (click)="addApproverComments()" style="width: 150px !important">
          Approver Comments
        </button>
        <div *ngIf="isGoalsSelected" class="text-style mt-4">
          <div class="col-md-12 ml-1 mt-3 text-secondary information"
            *ngIf="overallStatus=='DRAFT' || overallStatus=='NEW'">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please update the Affinity and Chapter Goals for the current fiscal year
              .</span>
          </div>
          <form #goalsForm="ngForm">
            <div style="display: flex" class="mt-3">
              <div class="col-md-4">
                <span class="font-weight-bold col-md-4">FY {{ fiscalYear }} Affinity Goals
                  <span class="mandatory-asterisk">*</span></span>
              </div>
              <div class="col-md-8 pr-0">
                <textarea class="form-control" rows="7" [(ngModel)]="affinityGoals" id="affinityGoals"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED'|| (overallStatus == 'REJECTED' && !goalsReview)}"
                  name="affinityGoals" maxlength="500"
                  [readonly]="overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED'|| (overallStatus == 'REJECTED' && !goalsReview) || adminId == '4'"
                  required>
              </textarea>
              </div>
            </div>

            <div style="display: flex" class="mt-4">
              <div class="col-md-4">
                <span class="font-weight-bold col-md-4">FY {{ fiscalYear }} Chapter Goals
                  <span class="mandatory-asterisk">*</span></span>
              </div>
              <div class="col-md-8 pr-0">
                <textarea class="form-control" rows="7" [(ngModel)]="chapterGoals" id="chapterGoals"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED'|| (overallStatus == 'REJECTED' && !goalsReview)}"
                  name="chapterGoals" maxlength="500"
                  [readonly]="overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED'|| (overallStatus == 'REJECTED' && !goalsReview) || adminId == '4'"
                  required>
              </textarea>
              </div>
            </div>


            <div style="display: flex" class="mt-4"
              *ngIf="((overallStatus == 'APPROVED' || overallStatus == 'REJECTED') && goalsReview) || (overallStatus == 'SUBMITTED' && adminId == '1')">
              <div class="col-md-4">
                <span class="font-weight-bold col-md-4"> Approver Comments on Goals</span>
              </div>
              <div class="col-md-8 pr-0">
                <textarea class="form-control" rows="4" [(ngModel)]="goalsReview" id="goalsReview"
                  [ngClass]="{'disableEdit': (overallStatus == 'APPROVED' && adminId != '1')|| overallStatus == 'REJECTED'}"
                  name="goalsReview" maxlength="500"
                  [readonly]="overallStatus == 'APPROVED' || overallStatus == 'REJECTED'">
            </textarea>
              </div>
            </div>
          </form>


          <div class="mt-5 text-center">
            <button
              *ngIf="overallStatus=='NEW' || overallStatus == 'DRAFT' || (overallStatus == 'SUBMITTED' && adminId == '1')|| (overallStatus=='REJECTED' && goalsReview) && adminId != '4'"
              class="btn btn-danger col-sm-2 col-md-2 button-font" [disabled]="!goalsForm.valid" (click)="saveGoals()">
              Save and Proceed
            </button>
            <button *ngIf="(adminId=='1' || !singleChapterAdmin) && overallStatus != 'APPROVED'"
              class="btn btn-danger col-sm-2 button-font" data-toggle="modal" data-target="#myModal"
              (click)="screenExit()">
              Cancel
            </button>
          </div>
          <div class="col-md-12 pr-0 mt-4 mb-3 text-center" *ngIf="overallStatus!= 'SUBMITTED'">
            <div [ngClass]="{ 'amount-style': overallStatus == 'APPROVED' || overallStatus == 'SUBMITTED' }"
              class="mb-5">
              <div class="col-md-6 float-left paddLzero space-style paddL" *ngIf="totalProposedBudget && 
              (overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED')">
                <span class="col-md-6 paddLzero font-headding pl-4">Requested Amount </span><span
                  class="col-md-1 font-headding">:</span>
                <span class="col-md-3 font-headding">{{
                  totalProposedBudget | currency : "USD"
                  }}</span>
              </div>
              <div class="col-md-6 float-right pr-0 paddLzero space-style" *ngIf="
                  (overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED')
                ">
                <span class="col-md-6 paddLzero font-headding paddM">Approved Amount</span><span
                  class="col-md-1 font-headding">:</span>
                <span class="col-md-5 font-headding">{{
                  totalApprovedBudget | currency : "USD"
                  }}</span>
              </div>
            </div><button class="btn btn-danger col-sm-2 button-font"
              *ngIf="(adminId == '1' && overallStatus == 'SUBMITTED')" (click)="approveOrReject('APPROVED')"
              data-toggle="modal" data-target="#myModal" [disabled]="!isAllHoshinsApproved">
              Approve
            </button>
            <button class="btn btn-danger col-sm-2 col-md-2 button-font"
              *ngIf="(adminId == '1' && overallStatus == 'SUBMITTED')" (click)="approveOrReject('REJECTED')"
              data-toggle="modal" data-target="#myModal" [disabled]="!isAnyInitiativeRejected">
              Reject
            </button>
            <button *ngIf="(adminId=='1' || !singleChapterAdmin) && overallStatus == 'APPROVED'"
              class="btn btn-danger col-sm-2 button-font" data-toggle="modal" data-target="#myModal"
              (click)="screenExit()">
              Cancel
            </button>
          </div>
        </div>

        <div *ngIf="isInitiativesSelected && !isAddNewInitiative">
          <div class="ml-3 mt-4 mb-3 text-secondary information" *ngIf="overallStatus=='SUBMITTED' && adminId=='1'">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please review and approve/reject initiatives using the Approver comments
              section .</span>
          </div>
          <div class="ml-2 mt-4 mb-3 text-secondary information"
            *ngIf="(overallStatus=='DRAFT' || overallStatus=='NEW') && prevInitiativeList.length==0">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please add Initiatives to submit the Hoshin . You can do this by adding each
              Initiative individually using the 'Add Initiative' button.</span>
          </div>
          <div class="ml-2 mt-4 mb-3 text-secondary information"
            *ngIf="(overallStatus=='DRAFT' || overallStatus=='NEW') && prevInitiativeList.length>0">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please add Initiatives to submit the Hoshin . You can do this either by
              adding each Initiative individually using the 'Add Initiative' button, or you can copy the initiatives
              from the current fiscal year by using the 'Copy FY{{ fiscalYearString | slice:-2}} Initiatives' button.</span>
          </div>
          <div class="card mt-4 card-style-initiative">
            <div class="nodata color-white" *ngIf="initiativeList.length == 0">
              <mat-icon class="notfound" style="color: black !important;">assignment</mat-icon>
              <div class="mt-4">No Initiatives added</div>
            </div>
            <div class="table-container" *ngIf="initiativeList.length > 0">
              <table aria-describedby="table" [ngClass]="{ 'table-responsive': tableresp }" class="table table-striped"
                id="tabledemo">
                <thead>
                  <tr class="tr-th">
                    <th scope="col" style="width: 40%;">BPG Initiative</th>
                    <th scope="col" style="width: 17%;"
                      *ngIf="overallStatus == 'DRAFT' || overallStatus == 'SUBMITTED' || overallStatus == 'NEW'">
                      Proposed Budget</th>
                    <th scope="col" style="width: 13%;">Frequency</th>
                    <th *ngIf="
                        overallStatus == 'SUBMITTED' ||
                        overallStatus == 'APPROVED' ||
                        overallStatus == 'REJECTED'
                      " scope="col" style="width: 13%;">
                      Status
                    </th>
                    <th *ngIf="
                        overallStatus == 'APPROVED' ||
                        overallStatus == 'REJECTED'
                      " scope="col" style="width: 13%;">
                      Approved Amount
                    </th>
                    <th class="text-center" *ngIf="!(overallStatus == 'SUBMITTED' && adminId==1)" scope="col"
                      style="width: 20%">Action</th>
                    <th class="text-center" *ngIf="overallStatus == 'SUBMITTED' && adminId=='1'" scope="col"
                      style="width: 20%">Action</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let data of initiativeList">
                    <td>
                      {{ data.bpgInitiative
                      }}<span *ngIf="data.isCloned && overallStatus == 'DRAFT'" class="ml-2 color">(cloned)</span>
                    </td>
                    <td *ngIf="overallStatus == 'DRAFT' || overallStatus == 'SUBMITTED' || overallStatus == 'NEW'">{{
                      data.proposedBudget | currency : "USD" }}</td>
                    <td>{{ data.frequency }}</td>
                    <td *ngIf="
                        overallStatus == 'SUBMITTED' ||
                        overallStatus == 'APPROVED' ||
                        overallStatus == 'REJECTED'
                      ">
                      <span *ngIf="data.isSuperAdminApproved == true">APPROVED</span>
                      <span *ngIf="data.isSuperAdminApproved == false">REJECTED</span>
                      <span *ngIf="data.isSuperAdminApproved == null">SUBMITTED</span>
                    </td>
                    <td *ngIf="
                        overallStatus == 'APPROVED' ||
                        overallStatus == 'REJECTED'
                      ">
                      {{ data.superAdminApprovedBudget | currency : "USD" }}
                    </td>
                    <td class="text-center" *ngIf="
                        overallStatus == 'DRAFT' ||
                        overallStatus == 'APPROVED' || (overallStatus == 'REJECTED' && adminId == '1') ||
                        (overallStatus == 'REJECTED' && !data.isSuperAdminApproved && adminId != '1') || overallStatus == 'NEW'
                      ">
                      <a id="editN{{ i }}" class="edit-delete"><img src="assets/images/edit.png" alt="Angular Logo"
                          class="image" title="Edit" (click)="editHoshin(data)" style="width: 20px !important" *ngIf="
                            overallStatus == 'DRAFT' ||
                            (overallStatus == 'APPROVED' && adminId=='1') ||
                            (overallStatus == 'REJECTED' && adminId != '4') || overallStatus == 'NEW'
                          " /></a>
                      <a class="edit-delete ml-2" id="deleteDi{{ i }}"><img src="assets/images/delete.png"
                          alt="Angular Logo" class="image" title="Delete" data-toggle="modal" data-target="#myModal"
                          style="width: 20px !important" (click)="deleteHoshin(data.hoshinId)" *ngIf="
                            overallStatus == 'DRAFT' ||
                            (overallStatus == 'REJECTED' && adminId != '4')  || overallStatus == 'NEW'
                          " /></a>
                      <a *ngIf="(overallStatus == 'APPROVED' && adminId != '1') || (overallStatus == 'REJECTED' && adminId == '4')"
                        class="edit-delete"><img src="assets/images/view.png" alt="Angular Logo" class="image"
                          title="View" id="bsaeHoshin" style="width: 20px !important" (click)="editHoshin(data)" /></a>
                    </td>
                    <td class="text-center" *ngIf="overallStatus == 'SUBMITTED' && adminId=='1'">
                      <a (click)="editHoshin(data,'approval')" class="color"
                        style="font-size: smaller; cursor: pointer;"><b>Click here to Approve</b></a>
                    </td>
                    <td class="text-center"
                      *ngIf="(overallStatus == 'SUBMITTED' && adminId!='1') || (overallStatus == 'REJECTED' && data.isSuperAdminApproved && adminId!='1')">
                      <a class="edit-delete"><img src="assets/images/view.png" class="image" title="View"
                          alt="Angular Logo" id="bsaeHoshin" style="width: 20px !important"
                          (click)="editHoshin(data)" /></a>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <p class="errorMessage mt-3 mb-3" *ngIf="errorMsgForMissingKpi != '' && !submitButtonClicked">
            Missing KPIs in : <span style="color: black;">{{ errorMsgForMissingKpi }}</span>
          </p>
          <p class="errorMessage mt-3 mb-3" *ngIf="errorMsgForMissingMandatoryFields != ''&& !submitButtonClicked">
            Missing Mandatory fields in : <span style="color: black;">{{ errorMsgForMissingMandatoryFields }}</span>
          </p>
          <div class="color col-md-6 offset-4 mt-4" *ngIf="submitButtonClicked && errorMsg != ''">
            {{errorMsg}}
          </div>
          <div *ngIf="submitButtonClicked && (errorMsgForMissingMandatoryFields != '' || errorMsgForMissingKpi != '')"
            class="color col-md-12 mt-4 mb-3">
            <div class="col-md-12 text-left">
              <div *ngIf="errorMsgForMissingKpi!='' && errorMsgForMissingMandatoryFields!=''">
                <div class="col-md-12" style="display:inline-flex;">
                  <div class="col-md-5">Missing Mandatory fields in Initiatives</div>
                  <span>:</span>
                  <div class="col-md-7"><span style="color: black;">{{errorMsgForMissingMandatoryFields}}</span></div>
                </div>
                <div class="col-md-12" style="display:inline-flex;">
                  <div class="col-md-6">Missing KPI's in Initiatives </div>
                  <span>:</span>
                  <div class="col-md-6"><span style="color: black;">{{errorMsgForMissingKpi}}</span></div>
                </div>
              </div>
              <div *ngIf="errorMsgForMissingMandatoryFields != '' && errorMsgForMissingKpi == ''" class="col-md-12"
                style="display:inline-flex;">
                <div class="col-md-5">Missing Mandatory fields in Initiatives</div>
                <span>:</span>
                <div class="col-md-7"><span style="color: black;">{{errorMsgForMissingMandatoryFields}}</span></div>
              </div>
              <div *ngIf="errorMsgForMissingKpi != '' && errorMsgForMissingMandatoryFields == ''" class="col-md-12"
                style="display:inline-flex;">
                <div class="col-md-6 text-right">Missing KPI's in Initiatives </div>
                <span>:</span>
                <div class="col-md-6"><span style="color: black;">{{errorMsgForMissingKpi}}</span></div>
              </div>
            </div>
          </div>
          <div class="mt-4 text-center" *ngIf="
              overallStatus != 'SUBMITTED' && !adminsEdit
            && overallStatus != 'APPROVED'">
            <button *ngIf="adminId != '4'" id="submitButton" class="btn btn-danger col-sm-2 button-font"
              (click)="submitPlanAndReview()">
              Submit Hoshin
            </button>
            <button *ngIf="adminId =='1' || !singleChapterAdmin" class="btn btn-danger col-sm-2 button-font"
              data-toggle="modal" data-target="#myModal" (click)="screenExit()">
              Cancel
            </button>
          </div>
          <div class="col-md-12 pr-0 mt-4 mb-3 text-center">
            <div class="col-md-12"
              [ngClass]="{ 'amount-style': overallStatus == 'APPROVED' || overallStatus == 'SUBMITTED' }" class="mb-3">
              <div class="col-md-6 float-left paddLzero space-style paddL" *ngIf="totalProposedBudget && 
            (overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED')">
                <span class="col-md-6 paddLzero font-headding">Requested Amount </span><span
                  class="col-md-1 font-headding">:</span>
                <span class="col-md-3 font-headding">{{
                  totalProposedBudget | currency : "USD"
                  }}</span>
              </div>
              <div class="col-md-6 float-right pr-0 pl-5 paddLzero space-style" *ngIf="
                (overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED')
              ">
                <span class="col-md-6 paddLzero font-headding paddM">Approved Amount</span><span
                  class="col-md-1 font-headding">:</span>
                <span class="col-md-5 font-headding">{{
                  totalApprovedBudget | currency : "USD"
                  }}</span>
              </div>
            </div>
          </div>
          <div class="text-center mt-5">
            <button class="btn btn-danger col-sm-2 button-font" *ngIf="(adminId == '1' && overallStatus == 'SUBMITTED')"
              (click)="approveOrReject('APPROVED')" data-toggle="modal" data-target="#myModal"
              [disabled]="!isAllHoshinsApproved">
              Approve
            </button>
            <button class="btn btn-danger col-sm-2 col-md-2 button-font"
              *ngIf="(adminId == '1' && overallStatus == 'SUBMITTED')" (click)="approveOrReject('REJECTED')"
              data-toggle="modal" data-target="#myModal" [disabled]="!isAnyInitiativeRejected">
              Reject
            </button>
            <button
              *ngIf="(adminId == '1' || !singleChapterAdmin) && (overallStatus == 'SUBMITTED' || overallStatus == 'APPROVED')"
              class="btn btn-danger col-sm-2 button-font" data-toggle="modal" data-target="#myModal"
              (click)="screenExit()">
              Cancel
            </button>
          </div>
        </div>
        <div *ngIf="
            isAddNewInitiative && isDetailsClicked && !approveOrRejectHoshin
          " class="text-style mt-2">
          <div class="ml-1 mb-3 text-secondary information"
            *ngIf="(isSuperAdminApproved == false) && !isKpiClicked && isDetailsClicked && overallStatus == 'REJECTED'">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please review Approver Comments and update the Initiatives .</span>
          </div>
          <div class="ml-1 mb-3 text-secondary information"
            *ngIf="overallStatus=='NEW' || overallStatus=='DRAFT' || (overallStatus=='REJECTED' && isSuperAdminApproved==null) ">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please add Initiative details to proceed further.</span>
          </div>
          <form #hoshinForm="ngForm">
            <div class="col-md-12 display-flex">
              <div class="col-md-6 form-row label-padding">
                <span class="col-md-4 label-padding control-label">BPG Initiative<span
                    class="mandatory-asterisk">*</span></span>
                <input type="text" placeholder="Enter initiative" id="bpgInitiative" maxlength="500" autocomplete="off"
                  class="col-md-7 collapse-control form-control input-lg inputs-padding" [(ngModel)]="bpgInitiative"
                  name="bpgInitiative"
                  [disabled]="overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  spellcheck="true" required [title]="bpgInitiative" />
              </div>
              <div class="col-md-6 ml-5 form-row label-padding">
                <label for="businessDrivers" class="col-md-4 label-padding control-label">Business Drivers<span
                    class="mandatory-asterisk">*</span></label>
                <ng-select id="businessDrivers" [items]="businessDriversList" placeholder="--Select--" bindLabel="type"
                  bindValue="type" [(ngModel)]="businessDrivers" name="businessDrivers"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}"
                  [disabled]="overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  class="col-md-7 form-control form-element input-lg custom outerdiv" (change)="getKpi()"
                  required></ng-select>
              </div>
            </div>

            <div class="col-md-12 display-flex">
              <div class="col-md-6 form-row label-padding">
                <label for="frequency" class="col-md-4 label-padding control-label">Frequency <span
                    class="mandatory-asterisk">*</span></label>
                <ng-select id="frequency" [items]="frequencyList" placeholder="--Select--" bindLabel="type"
                  bindValue="type" [(ngModel)]="frequency" name="frequency" required
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}"
                  [disabled]="overallStatus == 'SUBMITTED' || (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  class="col-md-7 form-control form-element input-lg custom outerdiv"></ng-select>
              </div>
              <div class="col-md-6 ml-5 form-row label-padding" *ngIf="frequency == 'Once'">
                <label for="estimatedTime" class="col-md-4 label-padding control-label">Estimated Timing<span
                    class="mandatory-asterisk">*</span></label>
                <input placeholder="Select month/year"
                  class="col-md-7 form-control inputs-padding collapse-control input-lg date-icon" id="estimatedTime"
                  name="estimatedTime{{ bpgInitiative }}" bsDatepicker autocomplete="off"
                  (onShown)="onOpenCalendar($event)" [ngModel]="estimatedTiming"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED' || (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}"
                  (ngModelChange)="onDateChange($event, i)"
                  [disabled]="overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  [bsConfig]="{ dateInputFormat: 'MMMM YYYY' }" [minDate]="minDate" [maxDate]="maxDate" required />
              </div>
            </div>
            <div class="col-md-12 display-flex">
              <div class="col-md-6 form-row label-padding">
                <label for="proposedBudget" class="col-md-4 label-padding control-label">Proposed Budget ($)<span
                    class="mandatory-asterisk">*</span></label>

                <input id="proposedBudget" type="number" autocomplete="off"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}"
                  class="col-md-7 collapse-control form-control input-lg inputs-padding" placeholder="Enter budget"
                  [(ngModel)]="proposedBudget" name="proposedBudget"
                  [readonly]="overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 "
                  required />
              </div>
              <div class="col-md-6 ml-5 form-row label-padding">
                <label for="leadId1" class="col-md-4 label-padding control-label">Initiative Lead</label>
                <ng-select id="businessDrivers" [items]="userList" placeholder="--Select--" bindLabel="userFirstName"
                  bindValue="userId" [(ngModel)]="leadId1" name="leadId1"
                  [disabled]="overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  class="col-md-7 form-control form-element input-lg custom outerdiv"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}">
                </ng-select>
              </div>
            </div>

            <div class="col-md-12 display-flex mb-2">
              <span class="alignleft form-row daycheck">
                <span>
                  <mat-checkbox class="mt-1"
                    [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}"
                    [checked]="isAdditionalFundingSelected"
                    [disabled]="overallStatus == 'SUBMITTED' || (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                    (change)="toggleFundingCheckbox($event)"></mat-checkbox>
                  <span class="bpg-name bold-text ml-3">Additional Funding
                  </span>
                </span>
              </span><br>
            </div>

            <div *ngIf="isAdditionalFundingSelected" class="col-md-12 display-flex">
              <div class="col-md-6 form-row align label-padding">
                <label for="additionalFunding" class="col-md-3 mb-0 pb-2 mr-3 label-padding control-label">Additional Funding
                  ($)</label>
                <input type="number" placeholder="Additional Funding" id="additionalFunding" maxlength="500"
                  autocomplete="off" class="col-md-7 ml-4 collapse-control form-control input-lg inputs-padding"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}"
                  [(ngModel)]="additionalFunding" name="additionalFunding"
                  [readonly]="overallStatus == 'SUBMITTED' || (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46" />
              </div>
              <div class="col-md-6 ml-5 form-row align label-padding">
                <label for="additionalFundingSource" class="col-md-4 mb-0 pb-2 control-label remove-title-margin">Additional
                  Funding Source</label>
                <input type="text" placeholder="Additional Funding Source" id="additionalFundingSource" maxlength="500"
                  autocomplete="off" class="col-md-7 collapse-control form-control input-lg inputs-padding"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}"
                  [(ngModel)]="additionalFundingSource"
                  [readonly]="overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  name="additionalFundingSource" spellcheck="true" />
              </div>
            </div>
            <div class="col-md-12 mt-3 pr-0 display-flex">
              <div class="col-md-12 form-row label-padding">
                <label for="actionPlan" class="col-md-2 textarea-label-padding control-label">Action Plan<span
                    class="mandatory-asterisk">*</span></label>
                <textarea class="form-control col-md-10 " rows="6" style="padding-left: 13px !important;"
                  id="actionPlan"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}"
                  [disabled]="overallStatus == 'SUBMITTED'|| (overallStatus == 'REJECTED' && adminId == '4') || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  name="actionPlan" maxlength="500" [(ngModel)]="actionPlan" required></textarea>

              </div>
            </div>
            <div *ngIf="(overallStatus == 'APPROVED' || overallStatus == 'REJECTED') && isSuperAdminApproved!=null"
              class="col-md-12 mt-3 pr-0 mb-4 display-flex">
              <div class="col-md-12 form-row label-padding">
                <span *ngIf="isSuperAdminApproved" class="col-md-2 textarea-label-padding control-label">Approval
                  Comments</span>
                <span *ngIf="!isSuperAdminApproved" class="col-md-2 textarea-label-padding control-label">Rejected
                  Comments</span>

                <textarea class="form-control col-md-10" style="padding-left: 13px !important;"
                  id="superAdminApprovalComments"
                  [ngClass]="{'disableEdit' : (overallStatus == 'APPROVED' || overallStatus == 'REJECTED') && adminId!='1'}"
                  [disabled]="(overallStatus == 'APPROVED' || overallStatus == 'REJECTED') && adminId!='1'"
                  name="superAdminApprovalComments" maxlength="500" [(ngModel)]="superAdminApprovalComments"></textarea>
              </div>
            </div>
            <div *ngIf="overallStatus == 'APPROVED'" class="col-md-12 mt-2 pr-0 display-flex">
              <div class="col-md-6 form-row label-padding">
                <label for="proposedBudget" class="col-md-4 label-padding control-label">Approved Amount ($)<span
                    class="mandatory-asterisk">*</span></label>

                <input id="proposedBudget" type="number" autocomplete="off"
                  [ngClass]="{'disableEdit': overallStatus == 'SUBMITTED' || (overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')}"
                  class="col-md-7 collapse-control form-control input-lg inputs-padding" placeholder="Enter budget"
                  [(ngModel)]="approvedBudget" name="approvedBudget"
                  [readonly]="(overallStatus == 'APPROVED' && adminId != '1') || (isSuperAdminApproved && adminId != '1')"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 "
                  required />
              </div>
              <div class="col-md-6 ml-5 form-row label-padding">
                <label for="claimedAmount" class="col-md-4 label-padding control-label">Claimed Amount ($)<span
                    class="mandatory-asterisk">*</span></label>

                <input id="claimedAmount" type="number" autocomplete="off"
                  class="col-md-7 collapse-control form-control input-lg inputs-padding" [(ngModel)]="claimedAmount"
                  name="claimedAmount" [readonly]="true" [ngClass]="{'disableEdit' : true}"
                  onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 " />
              </div>
            </div>
          </form>
          <div class="mt-4 mb-4 text-center">
            <button
              *ngIf="(overallStatus == 'NEW' || overallStatus == 'DRAFT' || (overallStatus == 'REJECTED' && !isSuperAdminApproved && adminId != '1') || (overallStatus == 'REJECTED' && adminId == '1') || (overallStatus == 'APPROVED' && adminId == '1')) && adminId != '4'"
              class="btn btn-danger col-sm-2 col-md-2 button-font" [disabled]="!hoshinForm.valid"
              (click)="saveHoshin()">
              Save and Proceed
            </button>
            <button
              *ngIf="(overallStatus == 'NEW' || overallStatus == 'DRAFT' || (overallStatus == 'REJECTED' && !isSuperAdminApproved && adminId != '1')|| (overallStatus == 'REJECTED' && adminId == '1') ||(overallStatus == 'APPROVED' && adminId == '1')) && adminId != '4'"
              class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi('cancelKpi')">
              Cancel
            </button>
            <button
              *ngIf="overallStatus == 'SUBMITTED' || (overallStatus == 'REJECTED' && isSuperAdminApproved && adminId != '1') || (overallStatus == 'APPROVED' && adminId != '1') || adminId == '4' "
              class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi()">
              Back To Initiatives
            </button>
          </div>
          <div></div>
        </div>
        <div
          *ngIf="(isKpiClicked && !approveOrRejectHoshin && (overallStatus=='NEW' ||overallStatus == 'DRAFT'|| (overallStatus == 'REJECTED' && isSuperAdminApproved == false && adminId != '4') || (overallStatus == 'REJECTED' && isSuperAdminApproved == null))) "
          class="ml-2 mb-3 text-secondary">
          <div class="information">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Please add Performance Indicators (KPIs) . You need to mandatorily choose one
              KPI from the existing options in the dropdown menu and include metrics. You can create a new KPI by
              using the 'Create new KPI' link.</span>
          </div>
          <br>
          <div class="information">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Step 1: Please select KPI from dropdown or add custom KPI.</span>
          </div>
        </div>
        <div class="nodata color-white" *ngIf="(kpiList==null || kpiList.length == 0) && isKpiClicked && !approveOrRejectHoshin">
          <mat-icon class="notfound" style="color: black !important;">assignment</mat-icon>
          <div class="mt-4">No KPIs added</div>
        </div>
        <div *ngIf="
            isAddNewInitiative &&
            isKpiClicked &&
            (kpiList!=null && kpiList.length != 0) &&
            !approveOrRejectHoshin
          " class="text-style">
          <div class="col-md-12 pl-0">
            <div
              *ngIf="overallStatus == 'NEW' || overallStatus == 'DRAFT' || adminsEdit ||  (overallStatus == 'REJECTED' && !isSuperAdminApproved && adminId != '1' && adminId != '4') || (overallStatus == 'REJECTED' && adminId == '1')"
              class="col-md-12 form-row align label-padding" style="margin-left: 15px;">
              <label for="kpi" class="col-md-1 label-padding control-label">KPI</label>
              <ng-select id="selectKpi" [items]="kpiList" placeholder="--Select KPI--" bindLabel="kpiName" name="kpi"
                bindValue="kpiId" [(ngModel)]="kpi" (change)="manageKpi($event)" style="font-size: 13px;"
                class="col-md-11 form-control form-element input-lg custom outerdiv">
              </ng-select>
            </div>
            <div
              *ngIf="overallStatus == 'NEW' || overallStatus == 'DRAFT' || adminsEdit ||  (overallStatus == 'REJECTED' && !isSuperAdminApproved && adminId != '1' && adminId != '4') || (overallStatus == 'REJECTED' && adminId == '1')"
              class="col-md-12 form-row align label-padding">
              <span class="col-md-1"></span>
              <a class="anchor text-medium-style color cursor-pointer mb-3 col-md-11 pl-4" style="margin-left:0"
                (click)="manageCustomKpi()">Click
                here to add custom kpi</a>
            </div>
          </div>
          <div class="ml-2 mb-3 text-secondary information" *ngIf="addCustomKpi && overallStatus != 'APPROVED'">
            <span>
              <mat-icon class="info-icon">info</mat-icon>
            </span>
            <span style="padding-top: 2px;">Step 2: Please add the count and click on add button .</span>
          </div>
          <div class="col-md-12 pr-0 display-flex" *ngIf="addCustomKpi">
            <div class="col-md-10 form-row align label-padding">
              <label for="kpiName" class="col-md-1 label-padding pl-2 control-label remove-title-margin"
                style="margin-right:7px">
                KPI</label>
              <input type="text" placeholder="Enter KPI" style="font-size: 13px;" id="kpiName" maxlength="500"
                autocomplete="off" class="col-md-10 ml-2 pl-2 collapse-control form-control input-lg inputs-padding"
                [(ngModel)]="kpiName" name="kpiName" [readonly]="kpiNameEditable" spellcheck="true" />
            </div>
            <div class="col-md-1 form-row align label-padding" style="width:15%">
              <input type="number" placeholder="Count" style="font-size: 13px;" id="kpiCount" maxlength="500"
                autocomplete="off" class="col-md-12 pl-2 collapse-control form-control input-lg" [(ngModel)]="kpiCount"
                name="kpiCount"
                onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46" />
            </div>
            <button *ngIf="!isEditKpi" class="col-md-1 btn btn-danger curve-edge button-font mt-2" style="width:7%"
              (click)="addNewKpi('add')" [disabled]="
                kpiName == null ||
                kpiName == undefined ||
                kpiName == '' ||
                kpiCount == null ||
                kpiCount == undefined ||
                kpiCount == ''
              ">
              Add
            </button>
            <button *ngIf="isEditKpi" class="btn btn-danger  curve-edge button-font mt-2" (click)="addNewKpi('update')"
              [disabled]="
                kpiName == null ||
                kpiName == undefined ||
                kpiName == '' ||
                kpiCount == null ||
                kpiCount == undefined ||
                kpiCount == ''
              ">
              Update
            </button>
          </div>

          <div class="ml-3 color-white card card-style-kpi" *ngIf="selectedKpiList.length > 0 && isKpiClicked">
            <table aria-describedby="table" [ngClass]="{ 'table-responsive': tableresp }"
              class="mt-4 table table-striped" id="tabledemo">
              <thead>
                <tr class="tr-th">
                  <th scope="col" class="text-center">KPI </th>
                  <th scope="col">Count</th>
                  <th
                    *ngIf="overallStatus == 'NEW' || overallStatus == 'DRAFT' || adminsEdit ||  (overallStatus == 'REJECTED' && !isSuperAdminApproved && adminId != '1' && adminId != '4') || (overallStatus == 'REJECTED' && adminId == '1')"
                    scope="col" style="width: 15%">
                    Update
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let data of selectedKpiList">
                  <td>{{ data.kpiName }}</td>
                  <td>{{ data.kpiCount }}</td>
                  <td
                    *ngIf="overallStatus == 'NEW' || overallStatus == 'DRAFT' || adminsEdit ||  (overallStatus == 'REJECTED' && !isSuperAdminApproved && adminId != '1' && adminId != '4') || (overallStatus == 'REJECTED' && adminId == '1')">
                    <a id="editN{{ i }}" class="edit-delete"><img src="assets/images/edit.png" class="image"
                        alt="Angular Logo" title="Edit" (click)="editKpi(data)" /></a>
                    <a class="edit-delete ml-2" id="deleteDi{{ i }}"><img src="assets/images/delete.png" class="image"
                        alt="Angular Logo" title="Delete" (click)="deleteKpi(data)" /></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="nodata color-white" *ngIf="selectedKpiList.length == 0">
            <mat-icon class="notfound" style="color: black !important;">assignment</mat-icon>
            <div class="mt-4">No KPIs added</div>
          </div>
          <div *ngIf="!readOnly" class="col-md-12 mt-5 mb-4 text-center">
            <button class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="saveKpi()"
              [disabled]="!enableSaveInitiativeButton"
              *ngIf="overallStatus == 'NEW' || overallStatus == 'DRAFT' || adminsEdit ||  (overallStatus == 'REJECTED' && !isSuperAdminApproved && adminId != '1' && adminId != '4') || (overallStatus == 'REJECTED' && adminId == '1')">
              Save Initiative
            </button>
            <button
              *ngIf="(overallStatus == 'NEW' || overallStatus == 'DRAFT' || (overallStatus == 'REJECTED' && !isSuperAdminApproved && adminId != '1') || (overallStatus == 'REJECTED' && adminId == '1')||(overallStatus == 'APPROVED' && adminId == '1')) && adminId != '4'"
              class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi('cancelKpi')">
              Cancel
            </button>
            <button *ngIf="overallStatus == 'SUBMITTED' || (overallStatus == 'APPROVED' && adminId != '1')"
              class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi()">
              Back To Initiatives
            </button>
          </div>
        </div>
        <div class="ml-4 mt-2" *ngIf="approveOrRejectHoshin">
          <span class="alignleft daycheck">
            <span>
              <mat-checkbox name="hoshinApproveClicked" [checked]="hoshinApproveClicked"
                (change)="toggleCheckbox($event)"></mat-checkbox>
              <span class="bpg-name bold-text ml-2">Click here to approve the Hoshin Initiative
              </span>
            </span>
          </span><br><br>
          <div class="col-md-12 form-row label-padding ml-2">
            <label for="proposedBudget" class="col-md-4 label-padding control-label">Proposed Budget ($)</label>

            <input id="proposedBudget" type="number" autocomplete="off" [ngClass]="{'disableEdit':true}"
              class="col-md-3 collapse-control form-control input-lg inputs-padding" [disabled]="true"
              [(ngModel)]="proposedBudget" name="proposedBudget" />
          </div>
          <div class="col-md-12 form-row label-padding ml-2" *ngIf="hoshinApproveClicked">
            <label for="approvedAmount" class="col-md-4 label-padding control-label">Approval Amount ($)<span
                class="mandatory-asterisk">*</span></label>

            <input id="approvedAmount" type="number" autocomplete="off"
              class="col-md-3 collapse-control form-control input-lg inputs-padding" placeholder="Enter amount"
              [(ngModel)]="approvedAmount" name="approvedAmount"
              onkeypress="return (event.charCode >= 48 && event.charCode <= 57) || event.charCode == 46 " required />
          </div>
          <div class="col-md-12 form-row label-padding">
            <span class="col-md-4 label-padding control-label" style="margin-left: 10px">Approval/ Reject Comment<span
                class="mandatory-asterisk">*</span></span>
            <textarea placeholder="Enter Comments" style="padding-left: 13px !important; font-size:0.8rem;"
              class="form-control col-md-5 " id="approveRejectComment" name="approveRejectComment" maxlength="500"
              [(ngModel)]="approveRejectComment" required></textarea>
          </div>
          <div class="mt-5 mb-4 text-center">
            <button class="btn btn-danger col-sm-2 col-md-2 button-font" data-toggle="modal" data-target="#myModal"
              (click)="submitApproval('approve')" [disabled]="
                !hoshinApproveClicked ||
                approvedAmount == null ||
                approvedAmount == undefined ||
                approveRejectComment == null ||
                approveRejectComment == undefined ||
                approveRejectComment == ''
              ">
              Approve
            </button>
            <button class="btn btn-danger col-sm-2 col-md-2 button-font" data-toggle="modal" data-target="#myModal"
              (click)="submitApproval('reject')" [disabled]="
                hoshinApproveClicked ||
                approveRejectComment == '' ||
                approveRejectComment == null ||
                approveRejectComment == undefined
              ">
              Reject
            </button>
            <button class="btn btn-danger col-sm-2 col-md-2 button-font" (click)="resetKpi()">
              Cancel
            </button>
          </div>
        </div>

        <app-confirmation-modal [PData]="msg" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
      </div>

      <div class="col-md-9 mt-5 pt-5 color text-center"
        *ngIf="displayType == 'plan' && adminId == '4' && (overallStatus == 'NEW' || overallStatus == 'DRAFT' || overallStatus == 'SUBMITTED')">
        <h5> No Hoshin available.This could be if Hoshin is still in draft / not submitted.</h5>
        <div class="text-center mt-5 pt-5">
          <button class="btn btn-danger col-sm-2 mt-5 button-font" data-toggle="modal" data-target="#myModal"
            (click)="screenExit()">
            Cancel
          </button>
        </div>
        <app-confirmation-modal [PData]="msg" (emitPass)="this[method](param)" id="2"></app-confirmation-modal>
      </div>

      <div *ngIf="isViewClicked" class="modal fade" id="bpgBaseModal" data-backdrop="true" tabindex="-1"
        style="background-color: rgba(0, 0, 0, 0.5)">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content font-color modal-top">
            <!-- Modal Header -->
            <div class="modal-header">
              <h4 class="modal-title">BPG Initiative</h4>
            </div>

            <!-- Modal body -->
            <div class="modal-body">
              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.bpgInitiative">
                <span class="col-md-4 paddLzero">BPG Initiative </span>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.bpgInitiative
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.businessDrivers">
                <label for="businessDrivers" class="col-md-4 paddLzero">Business Drivers</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.businessDrivers
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.proposedBudget">
                <label for="proposedBudget" class="col-md-4 paddLzero">Proposed Budget</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.proposedBudget | currency : "USD"
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.frequency">
                <label for="actionPlan" class="col-md-4 paddLzero">Frequency</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.frequency
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="
                  hoshinBase.frequency == 'Monthly' ||
                  hoshinBase.frequency == 'Quarterly'
                ">
                <label for="estimatedTiming" class="col-md-4 paddLzero">Estimated Timing</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.estimatedTiming
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.lead1Name == null">
                <label for="businessDrivers" class="col-md-4 paddLzero">Initiative Lead</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.lead1Name
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.actionPlan == ''">
                <label for="actionPlan" class="col-md-4 paddLzero">Action Plan</label>
                <span class="col-md-7 desc-color" [innerHtml]="hoshinBase.actionPlan">
                </span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.additionalFunding == null">
                <label for="superAdminApprovalComment" class="col-md-4 paddLzero">Additional Funding</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.additionalFunding | currency : "USD"
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="hoshinBase.additionalFundingSource == null">
                <label for="superAdminApprovalComment"
                  class="col-md-4 paddLzero additional-funding-text-align">Additional Funding Source</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.additionalFundingSource
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.superAdminApprovedBudget">
                <label for="superAdminApprovedBudget" class="col-md-4 paddLzero">Approval Amount</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.superAdminApprovedBudget | currency : "USD"
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.superAdminApprovalComment">
                <label for="superAdminApprovalComment" class="col-md-4 paddLzero">Approval Comment</label>
                <span class="col-md-7 desc-color">{{
                  hoshinBase.superAdminApprovalComment
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space" [hidden]="!hoshinBase.kpi">
                <label for="kpi" class="col-md-4 paddLzero">KPI</label>
                <span class="col-md-7 desc-color">
                  <p [innerHtml]="hoshinBase.kpi"></p>
                </span>
              </div>
            </div>
            <!-- Modal footer -->
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary btn-danger" data-dismiss="modal"
                (click)="isViewClicked = false">
                OK
              </button>
            </div>
          </div>
        </div>
      </div>

      <div id="printHoshins" [hidden]="true">
        <div *ngFor="let budgetData of printHoshinsList; let j = index">
          <div class="budget-control-outer-div comman-padding" *ngIf="budgetData.show">
            <div class="col-md-12 col-xs-12 col-sm-12 div-padding">
              <div class="col-md-12 col-xs-12 col-sm-12 heading">
                <span class="span-create-edit-hoshin">HOSHIN VIEW</span>
              </div>
              <div class="col-md-6 inlineFlex paddLzero space">
                <span class="col-md-5 paddLzero">Chapter</span>
                <span class="col-md-6 desc-color">{{siteName}} - {{ bpgName}}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space">
                <span class="col-md-5 paddLzero">Fiscal Year</span>
                <span class="col-md-6 desc-color">{{
                  budgetData.fiscalYear
                  }}</span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space">
                <span class="col-md-5 paddLzero">Affinity Goals</span>
                <span class="col-md-6 desc-color" [innerHtml]="budgetData.affinityGoals">
                </span>
              </div>
              <div class="col-md-6 inlineFlex paddLzero space">
                <span class="col-md-5 paddLzero">Chapter Goals</span>
                <span class="col-md-6 desc-color" [innerHtml]="budgetData.chapterGoals">
                </span>
              </div>

              <div class="col-md-6 inlineFlex paddLzero space">
                <span class="col-md-5 paddLzero">Budget Status</span>
                <span class="col-md-6 desc-color" [innerHtml]="budgetData.budgetStatus">
                </span>
              </div>
            </div>

            <div class="col-md-12 outerdiv">
              <div class="top-space1" *ngFor="let hoshin of budgetData.hoshinsList; let i = index">
                <div class="div-style">
                  <div class="col-md-6 mobile-pading">
                    <span class="budget-control budget-heading budget-name-width">
                      <span class="reponse-font">BPG Initiative </span>
                    </span>
                  </div>
                </div>

                <div id="budgetId{{ i }}" class="form-font-family"
                  [ngClass]="{ 'print-display': printClicked == true }">
                  <div class="col-md-6 inlineFlex paddLzero space">
                    <label for="bpgInitiative{{ i }}" class="col-md-4 paddLzero">BPG Initiative</label>
                    <span class="col-md-7 desc-color">{{
                      hoshin.bpgInitiative
                      }}</span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space">
                    <label for="businessDrivers{{ i }}" class="col-md-4 paddLzero">Business Drivers</label>
                    <span class="col-md-7 desc-color">{{
                      hoshin.businessDrivers
                      }}</span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.proposedBudget">
                    <label for="proposedBudget{{ i }}" class="col-md-4 paddLzero">Proposed Budget</label>
                    <span class="col-md-7 desc-color">${{ hoshin.proposedBudget }}</span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space">
                    <label for="actionPlan{{ i }}" class="col-md-4 paddLzero">Frequency</label>
                    <span class="col-md-7 desc-color">{{
                      hoshin.frequency
                      }}</span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.frequency == 'Once'">
                    <label for="estimatedTiming{{ i }}" class="col-md-4 paddLzero">Estimated Timing</label>
                    <span class="col-md-7 desc-color">{{
                      hoshin.estimatedTiming
                      }}</span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.lead1Name">
                    <label for="businessDrivers{{ i }}" class="col-md-4 paddLzero">Initiative Lead</label>
                    <span class="col-md-7 desc-color">{{
                      hoshin.lead1Name
                      }}</span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.actionPlan">
                    <label for="actionPlan{{ i }}" class="col-md-4 paddLzero">Action Plan</label>
                    <span class="col-md-7 desc-color" [innerHtml]="hoshin.actionPlan">
                    </span>
                  </div>
                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.kpi">
                    <label for="kpi{{ i }}" class="col-md-4 paddLzero">KPI</label>
                    <span class="col-md-7 desc-color" [innerHtml]="hoshin.kpi">
                    </span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.midYearResults">
                    <label for="midYearResults{{ i }}" class="col-md-4 paddLzero">Mid Year Results</label>
                    <span class="col-md-7 desc-color" [innerHtml]="hoshin.midYearResults">
                    </span>
                  </div>
                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.yearEndResults">
                    <label for="yearEndResults{{ i }}" class="col-md-4 paddLzero">Year End Results</label>
                    <span class="col-md-7 desc-color" [innerHtml]="hoshin.yearEndResults">
                    </span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.challenges">
                    <label for="challenges{{ i }}" class="col-md-4 paddLzero">
                      Challenges/Counter Measure</label>
                    <span class="col-md-7 desc-color" [innerHtml]="hoshin.challenges">
                      {{ hoshin.challenges }}
                    </span>
                  </div>

                  <div *ngIf="hoshin.additionalFunding != null" class="col-md-6 inlineFlex paddLzero space">
                    <label for="additionalFunding{{ i }}" class="col-md-4 paddLzero">Additional Funding</label>
                    <span class="col-md-7 desc-color">${{ hoshin.additionalFunding }}</span>
                  </div>

                  <div *ngIf="hoshin.evaluation != null" class="col-md-6 inlineFlex paddLzero space">
                    <label for="evaluation{{ i }}" class="col-md-4 paddLzero">Evaluation</label>
                    <span class="col-md-7 desc-color">{{
                      hoshin.evaluation
                      }}</span>
                  </div>

                  <div *ngIf="hoshin.additionalFundingSource != null" class="col-md-6 inlineFlex paddLzero space">
                    <label for="additionalFundingSource{{ i }}"
                      class="col-md-4 paddLzero additional-funding-text-align">Additional Funding Source</label>
                    <span class="col-md-7 desc-color">{{
                      hoshin.additionalFundingSource
                      }}</span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="hoshin.isSuperAdminApproved">
                    <label for="superAdminApprovedBudget{{ i }}" class="col-md-4 paddLzero">Approval Amount
                      <span *ngIf="this.budgetData.budgetStatus != 'APPROVED'">($)</span>

                      <span *ngIf="this.budgetData.budgetStatus != 'APPROVED'"
                        class="mandatory-asterisk">*</span></label>

                    <span *ngIf="this.budgetData.budgetStatus == 'APPROVED'" class="col-md-7 desc-color">${{
                      hoshin.superAdminApprovedBudget }}</span>
                  </div>

                  <div class="col-md-6 inlineFlex paddLzero space" *ngIf="
                      (this.budgetData.budgetStatus == 'SUBMITTED' &&
                        hoshin.superAdminApprovalComment) ||
                      (this.budgetData.budgetStatus == 'APPROVED' &&
                        hoshin.superAdminApprovalComment) ||
                      (this.budgetData.budgetStatus == 'REJECTED' &&
                        hoshin.superAdminApprovalComment)
                    ">
                    <label for="superAdminApprovalComment{{ i }}"
                      class="col-md-4 paddLzero remove-padding">Approval/Reject Comment
                      <span *ngIf="
                          this.budgetData.budgetStatus != 'APPROVED' &&
                          this.budgetData.budgetStatus != 'REJECTED'
                        " class="mandatory-asterisk">
                        *</span></label>

                    <span *ngIf="
                        this.budgetData.budgetStatus == 'APPROVED' ||
                        this.budgetData.budgetStatus == 'REJECTED'
                      " class="col-md-7 desc-color">{{ hoshin.superAdminApprovalComment }}</span>
                  </div>

                  <div *ngIf="hoshin.claimedAmount != null" class="col-md-6 inlineFlex paddLzero space">
                    <label for="claimedAmount{{ i }}" class="col-md-4 paddLzero">Claimed Amount</label>
                    <span class="col-md-7 desc-color">${{ hoshin.claimedAmount }}</span>
                  </div>
                </div>
              </div>

              <div class="amount-style">
                <div class="col-md-6 inlineFlex paddLzero space" *ngIf="budgetData.requestedBudgetAmount">
                  <span class="col-md-4 paddLzero remove-padding">Requested Amount
                  </span>
                  <span class="col-md-7 font-headding">${{ budgetData.requestedBudgetAmount }}</span>
                </div>
                <div class="col-md-6 inlineFlex paddLzero space">
                  <span class="col-md-4 paddLzero remove-padding">Approved Amount</span>
                  <span class="col-md-7 font-headding" *ngIf="budgetData.approvedBudgetAmount">${{
                    budgetData.approvedBudgetAmount }}</span>
                  <span class="col-md-7 font-headding" *ngIf="!budgetData.approvedBudgetAmount">$0</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>